import styled from 'styled-components';

const LoginContainer = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${props => props.theme.colors.primary};
`;

const LoginCard = styled.div`
  width: 600px;
  background: #fff;
  border-radius: 8px;
  padding: 50px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  form {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  ${props => props.theme.media.phone`
		width: 90%;
	`}

  ${props => props.theme.media.smallPhone`
		width: 95%;
	`}
`;

const LogoContainer = styled.div`
  width: 200px;
  height: auto;
  margin: 0 auto;
`;

const LogoImage = styled.img`
  width: 100%;
  height: auto;
`;

const LoaderContainer = styled.div`
  width: 100%;
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

export { LoginContainer, LoginCard, LogoContainer, LogoImage, LoaderContainer };
